import { SpecieQuota } from "interface/auction";
import { format } from "path";
import React, { FC } from "react";
import { formatNorwegianNumber } from "utils/helper";

const Page: FC<{ spaceQuota: SpecieQuota[] }> = ({ spaceQuota = [] }) => {
	return (
		<div>
			{spaceQuota.map((specie, index) => (
				<div key={index} style={{ marginTop: "30px" }}>
					<div className="text-bold">{specie.specieDescription}</div>
					{specie.lines.map((line, index) => (
						<Items
							key={index}
							field={line.description}
							value={line.netWeight ? line.netWeight.toString() : ""}
							unit={line.unit}
						/>
					))}
				</div>
			))}
		</div>
	);
};

const Items: FC<{ field: string; value: string; unit: string }> = ({
	field,
	value,
	unit,
}) => {
	const decimal = 2;
	let formattedValue = formatNorwegianNumber(Number(value), decimal, decimal);
	if (field === "") {
		formattedValue = "";
	}
	return (
		<div
			className="table-text"
			style={{
				display: "flex",
				justifyContent: "space-between",
				borderTop: "0.1px solid #dee2e6",
				// margin: "5px 0",
				height: "34px",
				alignItems: "center",
			}}
		>
			<div>{field}</div>
			<div style={{ fontWeight: 600 }}>
				{formattedValue} {unit}
			</div>
		</div>
	);
};

export default Page;
